<template>
  <JoinWrapper>
    <div class="sign_logo">
      <router-link to="/">
        <img src="@/assets/images/hakji_web_logo.png" alt="로고" />
      </router-link>
    </div>
    <div class="sign_inner">
      <div class="sns_wrap">
        <!-- <a
          href="http://localhost:8080/login/oauth2/code/kakao?id=094d59d2-0317-483f-b577-03f420c12682&type=NEW_USER"
          class="kakao"
        > -->
        <a href="javascript:void(0)" class="kakao" @click="kakao_login">
          <img
            src="@/assets/images/login_join/kakaotalk_logo.png"
            alt="카카오"
          />
          <span>카카오로 시작하기</span>
        </a>
        <a href="javascript:void(0)" class="naver" @click="naver_login">
          <img src="@/assets/images/login_join/naver_logo.png" alt="네이버" />
          <span>네이버로 시작하기</span>
        </a>
        <!-- <a href="#" class="teach" @click="registerUser"> -->
        <a href="#" class="teach" @click="goToStep1">
          <span>이메일로 시작하기</span>
        </a>
      </div>
      <div class="box bottom">
        <div class="bot_inner">
          <div class="already_member">
            이미 계정이 있나요?
          </div>
          <div class="email_login">
            <router-link to="/login" class="login">
              로그인
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </JoinWrapper>
</template>
<script>
import JoinWrapper from '@/components/auth/JoinWrapper.vue'
export default {
  name: 'SignUp',
  components: {
    JoinWrapper
  },
  methods: {
    kakao_login() {
      const redirect_uri =
        'https://www.campusbook.co.kr/login/oauth2/code/kakao'
      const client_id = '7ddb8fda4b0731c922688ed932a42fb3'
      const auth_url = `https://o2o-gwapi.campusbook.co.kr/oauth2/authorize/kakao?response_type=code&redirect_uri=${redirect_uri}&client_id=${client_id}`
      window.location.href = auth_url
    },
    naver_login() {
      const redirect_uri =
        'https://www.campusbook.co.kr/login/oauth2/code/naver'
      const client_id = '7JIYwgFBkaGiQ5svVJz5g'
      const auth_url = `https://o2o-gwapi.campusbook.co.kr/oauth2/authorize/naver?response_type=code&redirect_uri=${redirect_uri}&client_id=${client_id}`
      window.location.href = auth_url
    },
    goToStep1() {
      this.$router.push('/join/step1')
    },
    closeErrorModal() {
      this.showErrorModal = false
      this.erorrMessage = ''
    },
    toggleErrorModal() {
      this.showErrorModal = !this.showErrorModal
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.sign_logo {
  text-align: center;
  margin-bottom: 30px;
  img {
    width: 234px;
  }
}
.sns_wrap {
  margin-bottom: 24px;
  text-align: center;
  letter-spacing: 0;
  > a {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: 315px;
    height: 50px;
    margin: 0 auto 10px;
    border-radius: 20px;
    font-family: 'pretendard-medium';
    color: #1c1c1c;
    > span {
      user-select: none;
      font-size: 16px;
    }
    &.kakao {
      background-color: #f9e000;
    }
    &.naver {
      background-color: #2cb24a;
      color: #fff;
    }
    &.teach {
      margin-bottom: 0;
      background-color: #f1f1f1;
      color: #555353;
    }
    > img {
      user-select: none;
      width: 25px;
    }
  }
  > span {
    display: block;
    margin-bottom: 33px;
    font-family: 'pretendard-medium';
    font-size: 18px;
    color: $btn_box;
  }
}
.box {
  &.bottom {
    text-align: center;
  }
  .bot_inner {
    display: flex;
    justify-content: center;
    gap: 12px;
    .already_member {
      font-size: 14px;
      color: #777777;
      user-select: none;
    }
    .email_login {
      letter-spacing: 0;
      font-size: 15px;
      > a {
        letter-spacing: 0;
        text-decoration: underline;
        font-weight: 600;
        font-size: 14px;
        color: #515151;
      }
    }
  }
}
@media (max-width: 480px) {
  .sign_inner {
    padding: 0;
  }
  .sns_wrap > a {
    width: 100%;
  }
}
</style>
